export function isSneaker(productCategory: string): boolean {
  if (productCategory?.toLowerCase() === 'sneakers') {
    return true;
  }
  return false;
}
